export default __webpack_public_path__ + "static/media/bgDestination1.0ff25493.jpeg";